import { GithubFormat } from "./formatCode";

export const CONFIG_CODE = (template: string): GithubFormat => [
  {
      path : "index.ts",
      content: ``
  },
  // {
  //     path: 'index.tsx',
  //     content:``
  // },
  // {
  //     path: "App.tsx",
  //     content: ``
  // },
  {
    path : "tsconfig.json",
    content: `{
  "include": [
    "./**/*"
  ],
  "compilerOptions": {
    "strict": true,
    "esModuleInterop": true,
    "lib": [ "dom", "dom.iterable", "esnext" ],
    "jsx": "react-jsx",
    "target": "es2015",
    "module": "esnext",
    "moduleResolution": "node",
    "skipLibCheck": true
  }
}`
},
{
  path: "package.json",
  content: JSON.stringify({
    "dependencies": {
      "phaser": "3.90.0",
      "react": "19.1.0",
      "react-dom": "19.1.0",
      "react-scripts": "5.0.1"
    },
    "devDependencies": {
      "@types/react": "19.1.0",
      "@types/react-dom": "19.1.0",
      "eslint": "^8.57.1",
      "eslint-plugin-react": "^7.37.5",
      "jiti": "^2.5.1",
      "typescript": "^4.9.5",
      "typescript-eslint": "^8.43.0"
    },
    "main": "src/index.tsx",
    "scripts": {
      "start": "TSC_COMPILE_ON_ERROR=true ESLINT_NO_DEV_ERRORS=true DISABLE_ESLINT_PLUGIN=true react-scripts start",
      "build": "react-scripts build",
      "lint": "eslint \"./src/**/*.{js,jsx,ts,tsx}\" --quiet",
      "lint:fix": "eslint \"./src/**/*.{js,jsx,ts,tsx}\" --fix"
    },
    "browserslist": {
      "production": [
        ">0.2%",
        "not dead",
        "not op_mini all"
      ],
      "development": [
        "last 1 chrome version",
        "last 1 firefox version",
        "last 1 safari version"
      ]
    }
  }, null, 2)
},
{
  path: ".eslintrc.json",
  content: JSON.stringify({
    "env": {
      "browser": true,
      "es2021": true,
      "jest": true
    },
    "extends": [
      "eslint:recommended",
      "plugin:react/recommended",
      "plugin:@typescript-eslint/recommended"
    ],
    "parser": "@typescript-eslint/parser",
    "parserOptions": {
      "ecmaFeatures": {
        "jsx": true
      },
      "ecmaVersion": "latest",
      "sourceType": "module"
    },
    "plugins": [
      "react",
      "@typescript-eslint"
    ],
    "rules": {
      "react/jsx-uses-react": "off",
      "react/react-in-jsx-scope": "off",
      "@typescript-eslint/no-inferrable-types": "off"
    },
    "settings": {
      "react": {
        "version": "detect"
      }
    }
  }, null, 2)
},
{
  path: ".gitignore",
  content: `
# dependencies
/node_modules
package-lock.json
/.pnp
.pnp.js

# production
/build

# misc
.DS_Store
.env
.env*
.env.local
.env.development.local
.env.test.local
.env.production.local
.env.*

npm-debug.log*
yarn-debug.log*
yarn-error.log*
`
},
{
  path: "README.md",
  content: `
# playmix.ai game

to run the code:
- npm install
- npm start
`
}
];